import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Typography,
  Alert,
  CircularProgress,
  Box,
  IconButton,
  Tooltip
} from "@mui/material";
import {
  Print
} from "@mui/icons-material";

const ExpedicaoTable = ({ data, loading, showActions = true, onPrintInvoices }) => {

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <TableContainer 
        component={Paper}
        sx={{
          borderRadius: 1,
          border: "1px solid rgba(0,0,0,0.1)",
          backgroundColor: "white",
          height: "700px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          position: "relative",
          overflow: "auto"
        }}
      >
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255,255,255,0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10
            }}
          >
            <CircularProgress size={40} sx={{ color: "#FF7322" }} />
          </Box>
        )}
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell 
              sx={{ 
                fontWeight: 600, 
                color: "#333", 
                py: 1.5,
                backgroundColor: "#f8f9fa !important",
                borderBottom: "2px solid #e0e0e0",
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}
            >
              SKU
            </TableCell>
            <TableCell 
              sx={{ 
                fontWeight: 600, 
                color: "#333", 
                py: 1.5,
                backgroundColor: "#f8f9fa !important",
                borderBottom: "2px solid #e0e0e0",
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}
            >
              Produto
            </TableCell>
            <TableCell 
              align="center" 
              sx={{ 
                fontWeight: 600, 
                color: "#333", 
                py: 1.5,
                backgroundColor: "#f8f9fa !important",
                borderBottom: "2px solid #e0e0e0",
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}
            >
              ITENS
            </TableCell>
            <TableCell 
              align="center" 
              sx={{ 
                fontWeight: 600, 
                color: "#333", 
                py: 1.5,
                backgroundColor: "#f8f9fa !important",
                borderBottom: "2px solid #e0e0e0",
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px"
              }}
            >
              Etiquetas
            </TableCell>
            {showActions && (
              <TableCell 
                align="center" 
                sx={{ 
                  fontWeight: 600, 
                  color: "#333", 
                  py: 1.5,
                  backgroundColor: "#f8f9fa !important",
                  borderBottom: "2px solid #e0e0e0",
                  fontSize: "0.8rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  width: "120px"
                }}
              >
                Ações
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.length === 0 ? (
            <TableRow>
              <TableCell colSpan={showActions ? 5 : 4} align="center" sx={{ py: 4 }}>
                <Alert severity="info">
                  Nenhum item encontrado para os filtros selecionados.
                </Alert>
              </TableCell>
            </TableRow>
          ) : (
            data.map((item, index) => (
              <TableRow 
                key={index} 
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(255, 115, 34, 0.04)",
                    transform: "translateY(-1px)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    transition: "all 0.2s ease"
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "rgba(0,0,0,0.02)"
                  },
                  cursor: "pointer"
                }}
              >
                <TableCell sx={{ py: 1.5 }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontFamily: "monospace",
                      fontWeight: 600,
                      color: "#FF7322",
                      backgroundColor: "rgba(255, 115, 34, 0.1)",
                      padding: "3px 6px",
                      borderRadius: "4px",
                      display: "inline-block",
                      fontSize: "0.8rem"
                    }}
                  >
                    {item.sku}
                  </Typography>
                </TableCell>
                <TableCell sx={{ py: 1.5 }}>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      color: "#333",
                      fontWeight: 500,
                      lineHeight: 1.3,
                      fontSize: "0.85rem"
                    }}
                  >
                    {item.item_name}
                  </Typography>
                </TableCell>
                <TableCell align="center" sx={{ py: 1.5 }}>
                  <Box
                    sx={{
                      backgroundColor: "rgba(33, 150, 243, 0.1)",
                      color: "#2196f3",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      fontSize: "0.8rem",
                      display: "inline-block",
                      minWidth: "30px",
                      textAlign: "center"
                    }}
                  >
                    {item.total_quantity}
                  </Box>
                </TableCell>
                <TableCell align="center" sx={{ py: 1.5 }}>
                  <Box
                    sx={{
                      backgroundColor: "rgba(76, 175, 80, 0.1)",
                      color: "#4caf50",
                      padding: "4px 8px",
                      borderRadius: "8px",
                      fontWeight: 600,
                      fontSize: "0.8rem",
                      display: "inline-block",
                      minWidth: "30px",
                      textAlign: "center"
                    }}
                  >
                    {item.invoice_count}
                  </Box>
                </TableCell>
                {showActions && (
                  <TableCell align="center" sx={{ py: 1.5 }}>
                    <Box sx={{ display: "flex", gap: 0.5, justifyContent: "center" }}>
                      <Tooltip title="Imprimir Todas As Etiquetas de Transporte Recentes">
                        <span>
                          <IconButton
                            size="small"
                            onClick={() => onPrintInvoices && onPrintInvoices(item.sku)}
                            disabled={!onPrintInvoices}
                            sx={{
                              backgroundColor: onPrintInvoices ? "rgba(255, 115, 34, 0.1)" : "rgba(255, 115, 34, 0.05)",
                              color: onPrintInvoices ? "#FF7322" : "#ccc",
                              border: "1px solid rgba(255, 115, 34, 0.2)",
                              "&:hover": {
                                backgroundColor: onPrintInvoices ? "rgba(255, 115, 34, 0.2)" : "rgba(255, 115, 34, 0.05)",
                                transform: onPrintInvoices ? "scale(1.05)" : "none"
                              }
                            }}
                          >
                            <Print fontSize="small" />
                          </IconButton>
                        </span>
                      </Tooltip>
                    </Box>
                  </TableCell>
                )}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      </TableContainer>
    </Box>
  );
};

export default ExpedicaoTable;